'use strict';

import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

export const about = (() => {

    const init = () => {
        gsap.registerPlugin(ScrollTrigger);

        window.addEventListener('load', () => {
            ScrollTrigger.refresh();
        });

        story();
    };

    const story = () => {
        const section = document.querySelector('.story');
        const mosaic = document.querySelector('.story .story__mosaic');
        const slide = document.querySelector('.story .story__slide');
        const slideInner = document.querySelector('.story .story__slide-inner');
        const background = document.querySelector('.story .story__background');
        const foreground = document.querySelector('.story .story__foreground');
        const text = document.querySelectorAll('.story .story__text-inner span');

        const y = $('.menu__item.is-current').height() + $('.menu__item.is-current').find('.menu__child').height();
        const startPos = window.innerWidth > 768 ? `top +=${y}` : `top top`;

        const backgroundTrigger = gsap.timeline({
            scrollTrigger: {
                trigger: background,
                start: startPos,
                end: `+=${foreground.offsetHeight - window.innerHeight - (background.offsetHeight - window.innerHeight)}`,
                pin: true,
            }
        });

        const sectionTrigger = gsap.timeline({
            scrollTrigger: {
                trigger: background,
                start: `bottom bottom`,
                // end: `+=${foreground.offsetHeight - window.innerHeight}`,
                pin: true,
                scrub: true,
            }
        });

        sectionTrigger.to(slideInner, {
            x: (slideInner.offsetWidth - window.innerWidth) * -1,
            ease: 'none',
        });

        const sectionTrigger2 = gsap.timeline({
            scrollTrigger: {
                trigger: background,
                start: startPos,
                end: `+=${foreground.offsetHeight + window.innerHeight}`,
                toggleClass: {
                    targets: '.story .story__background',
                    className: 'is-fixed',
                }
            }
        });

        text.forEach((el, i) => {
            const textTrigger = gsap.timeline({
                scrollTrigger: {
                    trigger: el,
                    start: 'top 80%',
                    end: `+=${window.innerHeight}`,
                    toggleClass: {
                        targets: el,
                        className: 'is-show',
                    }
                }
            });
        });
    };

    return {
        init: init,
    };
})();
